import {signal} from '@angular/core';
import {RoutingMetadata} from '../../model/routing-metadata.model';
import {Theme} from '../../enum/theme.enum';

export const routingMetadata = signal<RoutingMetadata>({
  theme: Theme.BASE,
  logotypeUrl: "",
  faviconUrl: "",
  label: "",
});
